// extracted by mini-css-extract-plugin
export var black = "_2v-6";
export var brand = "_2v-1";
export var ddefault = "_2v-0";
export var error = "_2v-3";
export var gray = "_2v-2";
export var highContrast = "_2v-8";
export var outline = "_2v-7";
export var success = "_2v-5";
export var warning = "_2v-4";